import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { reFormatDate } from "../../../../utils/utils";
import { TotalsAccounts } from "./BodyA";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import SubRowsAccounts from "./SubRows";
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
}));

export const styleHA = {
    ...stElemnt.AF.header,
    backgroundColor: colors.grey[100],
    fontWeight: "bold",
    paddingTop: "2px",
    paddingBottom: "2px",
    border: "solid 0px",
    border: "solid 0.1px",
};
export const stylRo = {
    ...stElemnt.AF.cell,
    padding: "0px 1px",
}

export default function BodyItems(props) {
    const { data, isLast, infoData
    } = props;

    const { t } = useTranslation(["forms"]);

    return (
        <div>
            <TableContainer
                component={Paper}
                elevation={0}
                sx={{
                    width: "100%",
                    border: "1px solid #d9d9d9",
                    borderRadius: "6px",
                    overflow: "hidden",
                    direction: "rtl",
                    backgroundColor: "#fff",

                    "@media print": {
                        border: "1px solid #999",
                        borderRadius: 0,
                        boxShadow: "none",
                        overflow: "visible",
                    },
                }}
            >
                <Table
                    size="small"
                    sx={{
                        width: "100%",
                        borderCollapse: "collapse",
                        tableLayout: "fixed",
    
                        "& th": {
                            backgroundColor: "#f3f4f6",
                            color: "#222",
                            fontWeight: 700,
                            fontSize: "11px",
                            padding: "0px 0px",
                            borderBottom: "1.5px solid #777",
                            borderLeft: "1px solid #ddd",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                        },
    
                        "& td": {
                            fontSize: "10.5px",
                            color: "#222",
                            padding: "0px",
                            borderBottom: "1px solid #e2e2e2",
                            borderLeft: "1px solid #e5e5e5",
                            verticalAlign: "middle",
                        },
    
                        "& tbody tr:hover": {
                            backgroundColor: "#fafafa",
                        },
    
                        "& tbody tr:last-child td": {
                            borderBottom: "1px solid #999",
                        },
    
                        "@media print": {
                            "& th": {
                                backgroundColor: "#f1f1f1 !important",
                                WebkitPrintColorAdjust: "exact",
                                printColorAdjust: "exact",
                                fontSize: "9.5px",
                                padding: "0px 0px",
                                borderBottom: "1px solid #555",
                            },
    
                            "& td": {
                                fontSize: "9px",
                                padding: "0px",
                                borderBottom: "1px solid #ccc",
                            },
    
                            "& tbody tr": {
                                pageBreakInside: "avoid",
                                breakInside: "avoid",
                            },
                        },
                    }}
                >

                    {/* ================= HEADER ================= */}

                    <TableHead>
                        <TableRow>

                            <TableCell style={styleHA}
                                sx={{
                                    width: "25%",
                                }}
                            >
                                {t("note")}{" "}
                            </TableCell>
                            <TableCell style={styleHA}
                                sx={{
                                    width: "15%",
                                    textAlign: "right !important",
                                }}
                            >
                                {t("date")}{" "}
                            </TableCell>
                            <TableCell style={styleHA}
                                sx={{
                                    width: "15%",
                                }}
                            >
                                {"رقم المستند"}
                            </TableCell>

                            <TableCell style={styleHA}
                                sx={{
                                    width: "15%",
                                }}
                            >
                                {t("dept")}
                            </TableCell>
                            <TableCell style={styleHA}
                                sx={{
                                    width: "15%",
                                }}
                            >
                                {t("credit")}{" "}
                            </TableCell>

                            <TableCell style={styleHA}
                                sx={{
                                    width: "15%",
                                }}
                            >
                                {t("balance")}
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>

                        {/* مثال سجل */}
                        {data.map((row, i) => (
                            <>
                                <TableRow>

                                    <TableCell align="center" style={stylRo}>
                                        {row.notes}
                                    </TableCell>

                                    <TableCell style={stylRo}>
                                        {row?.doc_no}
                                    </TableCell>

                                    <TableCell align="center" style={stylRo}>
                                        {row.date != null ? reFormatDate(row?.date) : ""}
                                    </TableCell>

                                    <TableCell style={stylRo}>
                                        {row.dept.toFixed(2)}
                                    </TableCell>

                                    <TableCell align="left" style={stylRo}>
                                        {row.credit.toFixed(2)}
                                    </TableCell>

                                    <TableCell align="left" style={stylRo}>
                                        {row.Balance?.toFixed(2)}
                                    </TableCell>
                                </TableRow>


                                {/* ================= تفاصيل الأصناف ================= */}
                                {[1, 2, 3, 4].includes(row.type) == 1 && row.items?.length > 0 &&
                                    <SubRowsAccounts row={row} />
                                }
                            </>
                        ))}

                    </TableBody>


                </Table>
            </TableContainer>
            {isLast && <TotalsAccounts infoData={infoData} />}
        </div>
    );
}
